module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-跳转.a246f.png";